<script>
import getErrorMessage from '@/modules/server-errors';

//
// NOTE: This component is intentionally not translated.
//

export default {
  name: 'DowngradeDialog',
  data() {
    return {
      dialogVisible: false,
      isSubmitting: false
    };
  },
  methods: {
    show() {
      this.dialogVisible = true;
    },

    hide() {
      this.dialogVisible = false;
    },

    handleDowngrade() {
      this.isSubmitting = true;
      this.$http.put('/account/subscription', { cancelAtPeriodEnd: true })
        .then(res => {
          this.account = res.data.account;
          this.$store.commit('setAccount', this.account);
          this.hide();
        })
        .catch(err => {
          this.$notify({
            type: 'error',
            title: 'Error',
            message: getErrorMessage(err.response.data.code)
          });
        })
        .finally(() => this.isSubmitting = false);
    }
  }
};
</script>

<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="Cancel Subscription"
    class="downgrade-dialog"
  >
    <p>
      You will lose access to all premium features and you will only be allowed to manage websites
      for personal, educational, and non-profit use. Accounts are actively audited to prevent abuse.
    </p>
    <p>
      Are you sure you want to cancel your subscription?
    </p>

    <!-- Footer -->
    <span slot="footer">
      <el-button type="default" @click="hide">
        Do Not Cancel
      </el-button>
      <el-button :loading="isSubmitting" type="danger" @click="handleDowngrade">
        Yes, Cancel
      </el-button>
    </span>
  </el-dialog>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.downgrade-dialog {
  /deep/ .el-dialog__body {
    p {
      line-height: 1.4;
      margin-top: 0;
    }
  }
}

.cancel-image {
  display: block;
  width: 10rem;
  height: auto;
  float: right;
  margin: 0 0 0 1rem;

  @include breakpoint('sm-and-down') {
    width: 6rem;
  }
}
</style>
